import React, { useState, useEffect, useRef } from 'react'
import {
  Panel,
  Message,
  Row,
  Col,
  ControlLabel,
  Input,
  DatePicker,
  Uploader,
  Icon,
  Table,
} from 'rsuite'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import { isImageOrPdf, isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import { cloneDeep, isEmpty } from 'lodash-es'
import { LOCAL_DAY_TH } from '../../constants/date'
import moment from 'moment'
import { sessionGetItemObj, sessionGetItemStr } from '../../utils/sessionHelpers'
import PanelHeader from '../../components/PanelHeader'
import notification from '../../utils/notification'
import IncomeRecordFileTable from '../incomeRecordWidget/IncomeRecordFileTable'
import { downloadSubProjectExpenseRecordAttacthment } from '../../redux/actions/subprojectExpenseRecord'
import { startLoading, doneLoading } from '../../utils/loading'
import globalMsgUtil from '../../utils/globalMsgUtil'
import { downloadFile, previewFile } from '../../utils/fileUtil'
import { getDateThaiShort } from '../../utils/dataUtil'

export default function SubprojectExpenseRecordView({
  schema: _schema,
  register,
  errors,
  error,
  Controller,
  control,
  setValue,
  clearErrors,
  getValues,
  ...props
}) {
  const triggerRef = React.useRef()
  const { Column, HeaderCell, Cell } = Table
  const [formSchema, setFormSchema] = useState(_schema)

  const [valueShow, setValueShow] = useState(false)
  // const [expenseForVal, setExpenseForValVal] = useState(_schema.expenseFor.value)
  const [fileTypeError, setFileTypeError] = useState(false)
  const [showPendingTaxList, setShowPendingTaxList] = useState(false)
  const { periodNo, startAndEndDate, periodOfLength } = sessionGetItemObj('subProjectPeriodInfo')
  const projectCode = sessionGetItemStr('projectCode')
  const subProjectCode = sessionGetItemStr('subProjectCode')
  const subExpenseId = sessionGetItemStr('subExpenseId')
  const [fileTableData, setFileTableData] = useState([])
  const [titleLeftStr, setTitleLeftStr] = useState('')
  const [titleRightStr, setTitleRightStr] = useState('')

  useEffect(() => {
    setTitleLeftStr(`งวดที่ ${periodNo || ''} (${startAndEndDate || ''})`)
    setTitleRightStr(`งวดที่ ${periodNo || '0'} / ${periodOfLength || '0'}`)

    setFileTableData(formSchema?.attachFiles?.values)
  }, [formSchema])

  const onPreview = async (fileObj) => {
    // console.log('onPreview', fileObj)
    startLoading()
    try {
      var file = await downloadSubProjectExpenseRecordAttacthment(fileObj.id)
      var fileName = fileObj.label

      previewFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'ดาวน์โหลด ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
  }

  const onDownload = async (fileObj) => {
    // console.log('onDownload', fileObj)
    startLoading()
    try {
      var file = await downloadSubProjectExpenseRecordAttacthment(fileObj.id)
      var fileName = fileObj.label

      downloadFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'ดาวน์โหลด ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    doneLoading()
  }

  const handleDeleteFileTable = async (rowData) => {
    // console.log('handleDeleteFileTable', rowData)

    let arr = getValues('deleteFileIds') || []
    arr.push(rowData.id)

    let _fileTable = fileTableData?.filter((item) => item.id != rowData.id)
    setFileTableData(_fileTable)
  }

  return (
    <>
      <Panel
        bordered
        style={{
          marginTop: 25,
          border: '1px solid #4e4b488c',
        }}
        header={<PanelHeader leftString={titleLeftStr} rightString={titleRightStr} />}
      >
        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>{formSchema.voucherNumber.label}</ControlLabel>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <p>{` : ${formSchema.voucherNumber.value || ''}`}</p>
          </Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.referenceNumber.label}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <p>{` : ${formSchema.referenceNumber.value || ''}`}</p>
          </Col>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.voucherDate.label}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <p>{` : ${getDateThaiShort(formSchema.voucherDate.value)}`}</p>
          </Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.description.label}
          </Col>
          <Col lg={20} md={20} sm={24} xs={24}>
            <p>{` : ${formSchema.description.value || ''}`}</p>
          </Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.attachFiles.label}
          </Col>
          <Col lg={20} md={20} sm={24} xs={24}>
            <IncomeRecordFileTable
              data={fileTableData}
              deleteable={false}
              onPreview={onPreview}
              onDownload={onDownload}
            />
          </Col>
        </Row>
      </Panel>
    </>
  )
}
